import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IDatesPanelButtonProps } from './types';
import { DATES_TITLE } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function DatesPanelButton ({
    onClick
}: IDatesPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.DATES_TIME}
            title={DATES_TITLE}
            onClick={() => {
                setSubTab(EBoardSetting.DATES_TIME);
                onClick();
            }}
        />
    );
}
